<template>
  <div class="redirect-page" />
</template>

<style scoped>
.redirect-page {
  min-height: 100vh;
}
</style>